<template>
  <div
    class="application-base"
    :class="{'application-base--preview': view === 'preview'}"
  >

    <!-- ------
     --- MODALS
     --- ------ -->

    <div v-if="userLoggedOut">
      userLoggedOut
    </div>

    <!-- TODO: What is this? -> comment -->
    <ApplicationModal
      v-if="modals.loadPreset.show"
      :title="modals.loadPreset.title"
    >
      {{modals.loadPreset.content}}

      <template v-slot:actions="slot">
        <button
          class="btn btn--large"
          :class="[`btn--${color}`, slot.classAction]"
          @click="$emit('showModal', 'loadPreset', false)"
        >
          {{modals.loadPreset.textClose}}
        </button>
      </template>
    </ApplicationModal>

    <!-- -------------------------------------------
     --- Confirmation modal to reset the application
     --- ------------------------------------------- -->

    <ApplicationModal
      v-if="modals.confirmReset.show"
      :title="textReset"
    >
      {{textResetConfirm}}

      <template v-slot:actions="slot">
        <button
          class="btn btn--large btn--outline"
          :class="[`btn--${color}`, slot.classAction]"
          @click="$emit('showModal', 'confirmReset', false)"
        >
          {{translate('Peruuta')}}
        </button>

        <!-- Logout / Update -->
        <button
          class="btn btn--large"
          :class="[`btn--${color}`, slot.classAction]"
          @click="move('reset')"
        >
          {{textReset}}
        </button>
      </template>
    </ApplicationModal>

    <!-- Confirmation modal for deactivating the application -->
    <ApplicationModal
      v-if="modals.confirmDeactivation.show"
      :title="textDeactivateConfirmTitle"
    >
      {{textDeactivateConfirmText}}

      <template v-slot:actions="slot">
        <button
          class="btn btn--large btn--outline"
          :class="[`btn--green`, slot.classAction]"
          @click="$emit('showModal', 'confirmDeactivation', false)"
        >
          {{translate('Peruuta')}}
        </button>
        <button
          class="btn btn--large"
          :class="[`btn--green`, slot.classAction]"
          @click="[$emit('showModal', 'confirmDeactivation', false), move('deactivateApplication')]"
        >
          {{textDeactivateButton}}
        </button>
      </template>
    </ApplicationModal>

    <OrderNumberModal />

    <!-- New form send success -->
    <div
      v-if="view === 'form' || view === 'success'"
      class="backdrop-container backdrop-container--contain"
      :class="{'application-base--success': view === 'success'}"
    >

      <!--
        Show main title if we are loading the view OR
        response was successfull
        -->

      <div class="container" v-if="(applicationDataLoading || applicationDataResponseSuccess) || usingLocalStorage">
				<h1
          class=""
          v-html="hero.title"
        />
      </div>

      <!-- ------------------
       --- Content are starts
       --- ------------------ -->

      <!-- Show spinner if loadApplicationDataFromAPI not ready -->
      <LoadSpinner
        v-if="applicationDataLoading && !usingLocalStorage"
        :margin="false"
      />

      <!-- ----------------------------------------------------------------------
       --- If application data wasn't provided, or we have an ERROR.
       --- This usually happens when there isn't application for the provided ssn
       --- ---------------------------------------------------------------------- -->

      <div class="container container--narrow" v-if="!applicationDataLoading && usingLocalStorage === false && !applicationDataResponseSuccess">

        <h1 class="h2 text-align-left mb-4">
          {{eidsNoApplicationTitle}}
        </h1>

        <div class="wysiwyg mb-ts-1 mb-4" v-html="eidsNoApplicationMessage" />

        <a class="btn mb-5" v-bind:href="eidsNoApplicationLinkUrl">
          {{eidsNoApplicationLinkTitle}}
        </a>
      </div>

      <!-- -----------------------------------------
       --- Successful response
       --- this.applicationDataResponseSuccess: true
       --- Show the form
       --- ----------------------------------------- -->

      <div id="application-wrapper"
           v-if="(!applicationDataLoading && applicationDataResponseSuccess) || usingLocalStorage">

        <!-- Application base top -->
        <div class="container container--narrow application-section application-base__top">
            <ApplicationSection
              v-if="view === 'form' && applicationType != 'owner-occupancy'"
              :title="translate('Hakemuksesta')"
              class="print-hide"
            >
              <div class="application-base__instructions wysiwyg">
                <div v-html="textBefore"/>
              </div>
            </ApplicationSection>
            <ApplicationSection
                v-if="view === 'form' && applicationType == 'owner-occupancy'"
                :title="translate('Varausseloste')"
                class="print-hide"
              >
                <div class="application-base__instructions wysiwyg">
                  <div v-html="textBefore"/>
                </div>
              </ApplicationSection>

            <div
              v-if="$slots.top && applicationType != 'owner-occupancy'"
              class="application-base__top-slot"
            >
              <slot name="top"/>
            </div>
        </div>

        <ApplicationDivider v-if="view === 'form' && warningApartmentsBefore" />

        <!-- ApplicationSection & ApplicationApartments -->
        <div class="container container--narrow application-section">

          <ApplicationSection v-if="view === 'form' && warningApartmentsBefore">
            <div
              class="wysiwyg warning-text print-hide"
              :class="`border--${color}`"
              v-html="warningApartmentsBefore"
            />
          </ApplicationSection>

          <!-- ApplicationApartments -->
          <div class="application-base__apartments">
            <slot name="apartments"/>
          </div>

        </div>

        <!-- ApplicationApplicants -->
        <slot/>

        <div class="container container--narrow application-section">
          <ApplicationSection v-if="view === 'form' && applicationType != 'owner-occupancy'">
            <div
              v-if="textAfter"
              class="wysiwyg warning-text print-hide"
              :class="`border--${color}`"
              v-html="textAfter"
            />
          </ApplicationSection>
        </div>
        <ApplicationDivider v-if="view === 'form' && textAfter && applicationType != 'owner-occupancy'" wrapperClasses="container" />

        <!-- ------------------------------------------------
         --- Bottom grid for printing and application buttons
         --- ------------------------------------------------ -->

        <div class="container">
          <div class="application-base__bottom-grid">
            <div class="application-base__bottom-grid-item--left application-base__bottom-grid-row print-hide">

              <!-- -----------
               --- Left column
               --- ----------- -->

              <div class="application-base__center-button">

                <!-- Print -->
                <button
                  @click="print"
                  class="btn btn--white btn--outline btn--large"
                >
                  <PrintIcon
                    class="application-base__print-icon"
                    :class="`icon--${color}`"/>
                    {{
                      applicationType != 'owner-occupancy' ?
                      translate('Tulosta hakemus') :
                      translate('Tulosta varaus')
                    }}
                </button>
              </div>

            </div>

            <!-- Right column -->
            <div class="application-base__bottom-grid-item--right application-base__bottom-grid-column">

                <div
                  v-if="showSubmitValidationBanner"
                  class="application-base__bottom-label application-base__error"
                >
                  {{translate('Täytä puuttuvat kentät.')}}
                </div>

                <div
                  v-if="!loading && !hasApartments"
                  class="application-base__bottom-label application-base__error print-hide"
                >
                  {{translate('Hakemuksella ei ole asuntoja.')}}
                </div>

                <div class="application-base__bottom-label">
                  <InputCheckbox v-model="agree"
                    wrapperClasses="input-wrapper input-wrapper--flex"
                  >
                    {{labelAgree.start}}

                    <a v-if="labelAgree.insertLink"
                      :href="urlTerms"
                      target="_blank"
                      class="application-base__terms-link"
                    >
                      {{translate('hyväksyn käyttöehdot')}}
                    </a>
                    {{labelAgree.end}}
                  </InputCheckbox>
                </div>

                <div
                  v-if="submitError"
                  class="application-base__error application-base__bottom-label"
                >
                  {{translate('Hakemuksen lähetys epäonnistui.')}}
                </div>

                <div
                  v-if="deactivateError"
                  class="application-base__error application-base__bottom-label"
                >
                  {{translate('Hakemuksen poistaminen epäonnistui.')}}
                </div>

              <!-- -------------------------------------
               --- The right section has been divided to
               --- inner 2 columns containing buttons
               --- ------------------------------------- -->

              <div class="row g-4">

                <!-- Left buttons -->
                <div class="col-sm-6">
                  <button
                    v-if="view === 'form'"
                    @click="$emit('showModal', 'confirmReset', true)"
                    class="btn btn--large btn--outline w-100"
                    :class="`btn--${color}`"
                  >
                    {{textReset}}
                  </button>

                  <!-- Deactivate -->
                  <button
                    v-if="view === 'form' && this.isExistingApplication"
                    @click="$emit('showModal', 'confirmDeactivation', true)"
                    class="application-base__btn-wide btn btn--large print-hide btn--pink w-100"
                    style="margin-top: 1rem;"
                    :id="`application-base-button-${applicationType}-deactivate`"
                    :data-id="`application-base-button-${applicationType}-deactivate`"
                  >
                    <LoadSpinner
                      v-if="deactivating"
                      :margin="false"
                    />
                    <template v-else>
                      {{textDeactivate}}
                    </template>
                  </button>

                </div>

                <!-- Right buttons -->
                <div class="col-sm-6">
                  <button
                    @click="move('submit')"
                    class="application-base__btn-wide btn btn--large print-hide w-100"
                    :class="`btn--${color}`"
                    :disabled="submitDisabled"
                    :id="`application-base-button-${applicationType}-2003`"
                    :data-id="`application-base-button-${applicationType}-2003`"
                  >
                    <LoadSpinner
                      v-if="submitting"
                      :margin="false"
                    />
                    <template v-else>
                      {{textSubmit}}
                    </template>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ----------------------------------------------------
       --- Fixed position Modal on bottom right corner
       --- has buttons for logout AND Updating the application.
       --- ---------------------------------------------------- -->

      <div
        class="application-base__controls-fixed print-hide"
        v-if="view === 'form'"
      >
        <div
          v-if="textFixedControls"
          class="application-base__controls-fixed-text"
        >
          {{textFixedControls}}
        </div>
        <div class="application-base__controls-fixed-buttons">
          <button
            @click="$emit('showModal', 'confirmReset', true)"
            class="btn btn--outline"
            :class="`btn--${color}`"
          >
            {{textReset}}
          </button>
          <button
            @click="move('submit')"
            class="btn"
            :class="`application-base__controls-fixed-submit btn--${color}`"
            :disabled="submitDisabled"
            :id="`application-base-button-${applicationType}-2003b`"
            :data-id="`application-base-button-${applicationType}-2003`"
          >
            <LoadSpinner
              v-if="submitting"
              :margin="false"
            />
            <template v-else>
              {{textSubmit}}
            </template>
          </button>
        </div>
      </div>

      <!--
        Submit form message
        if we haven't been redirected to the OIDC logout
        --->
      <div
        v-if="view === 'success' || view === 'deactivation-success'"
        class="backdrop-container print-hide"
      >

        <div class="application-success container">

          <div class="application-success__item">
            <div class="application-success__row">
              <div
                class="application-success__column application-success__content wysiwyg"
                v-html="success.content"
              />
            </div>
          </div>

          <div
            v-if="view !== 'deactivation-success'"
            class="application-base__center-button application-success__print"
          >
            <button
              @click="print"
              class="btn btn--white btn--outline btn--large"
            >
            <PrintIcon
              class="application-base__print-icon"
              :class="`icon--${color}`"/>
              {{translate('Tulosta hakemus')}}
            </button>
          </div>

          <div
            v-if="success.applyOther.show"
            class="application-success__item"
          >
            <div class="application-success__title">
              {{success.applyOther.title}}
            </div>
            <div class="application-success__row">
              <div class="application-success__column application-success__column--large">
                <div
                  class="application-success__content wysiwyg"
                  v-html="success.applyOther.content"
                />
              </div>
              <div class="application-success__column application-success__column--small">
                <button
                  @click="move('applyOther')"
                  :class="`btn--${success.applyOther.color}`"
                  class="btn btn--large"
                >
                  {{success.applyOther.ctaText}}
                  <ArrowIcon class="btn__icon btn__icon--right" />
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> <!-- #application-wrapper ends -->

    <!-- SUCCESS -->
    <div
      v-if="view === 'success' || view === 'deactivation-success'"
      class="backdrop-container print-hide"
    >
      <div class="application-success container">

        <h1
          class="h2 text-align-left mb-5"
          v-html="hero.title"
        />

        <div class="application-success__item">
          <div class="application-success__row">
            <div
              class="application-success__column application-success__content wysiwyg"
              v-html="success.content"
            />
          </div>
        </div>

        <div
          v-if="view !== 'deactivation-success'"
          class="application-base__center-button application-success__print"
        >
          <button
            @click="print"
            class="btn btn--white btn--outline btn--large"
          >
            <PrintIcon
              class="application-base__print-icon"
              :class="`icon--${color}`"/>
            {{translate('Tulosta hakemus')}}
          </button>
        </div>

        <div
          v-if="success.applyOther.show"
          class="application-success__item"
        >
          <div class="application-success__title">
            {{success.applyOther.title}}
          </div>
          <div class="application-success__row">
            <div class="application-success__column application-success__column--large">
              <div
                class="application-success__content wysiwyg"
                v-html="success.applyOther.content"
              />
            </div>
            <div class="application-success__column application-success__column--small">
              <button
                @click="move('applyOther')"
                :class="`btn--${success.applyOther.color}`"
                class="btn btn--large"
              >
                {{success.applyOther.ctaText}}
                <ArrowIcon class="btn__icon btn__icon--right" />
              </button>
            </div>
          </div>
        </div>

      </div>
    </div><!-- Success message ends -->



    </div>
</template>

<script>
  import {FinnishSSN} from 'finnish-ssn';
  import globals from '../../lib/globals';

  import ApplicationSection from './ApplicationSection';
  import ApplicationDivider from './ApplicationDivider';
  import ApplicationModal from './ApplicationModal';
  import OrderNumberModal from './OrderNumberModal';
  import InputWrap from './InputWrap';
  import InputTextarea from './InputTextarea';
  import InputCheckbox from './InputCheckbox';
  import LoadSpinner from './LoadSpinner';
  import ArrowIcon from '../icons/ArrowIcon.vue';
  import PrintIcon from '../icons/PrintIcon.vue';
  import { updateCookieWithString } from "../../lib/cookieUtils";
  import {createURLWithParams, maybeAddQueryParam} from "../../lib/urlUtils";

  // Mixins.
  import hCaptcha from '../mixins/hCaptcha';
  import utils from '../mixins/utils';

  export default {
    mixins: [
      utils.translate,
      hCaptcha,
    ],
    components: {
      ApplicationSection,
      ApplicationDivider,
      ApplicationModal,
      OrderNumberModal,
      InputWrap,
      InputTextarea,
      InputCheckbox,
      LoadSpinner,
      ArrowIcon,
      PrintIcon
    },
    props: {
      applicationType: {
        type: String,
        default: '',
      },
      applicationTypeOriginal: {
        type: String,
        default: '',
      },
      view: {
        type: String,
        required: true,
      },
      hero: {
        type: Object,
        required: true,
      },
      textBefore: {
        type: String,
        default: '',
      },
      textAfter: {
        type: String,
        default: '',
      },
      warningApartmentsBefore: {
        type: String,
        default: '',
      },
      success: {
        type: Object,
        required: true,
      },
      validations: {
        type: Object,
        required: true,
      },
      /** True after user tried preview/submit with invalid form — shows summary + InputWrap errors. */
      formSubmitAttempted: {
        type: Boolean,
        default: false,
      },
      submitting: {
        type: Boolean,
        required: true,
      },
      deactivating: {
        type: Boolean,
        required: true,
      },
      loading: {
        type: Boolean,
        required: true,
      },
      submitError: {
        type: Boolean,
        required: true,
      },
      deactivateError: {
        type: Boolean,
        required: true,
      },
      hasApartments: {
        type: Boolean,
        required: true,
      },
      isExistingApplication: {
        type: Boolean,
        required: true,
      },
      existingApplicantIndexes: {
        type: Object,
        default() { return {} },
        required: true,
      },
      color: {
        type: String,
        default: 'default',
      },
      theOtherColor: {
        type: String,
        default: 'default',
      },
      modals: {
        type: Object,
        required: true,
      },
      loadApplicationDataFromAPI: {
        type: Function
      },
      logoutUser: {
        type: Function
      },
      userLoggedOut: {
        type: Boolean,
        default: false,
      },
      disableFormFromWordPress: {
        type: Boolean,
        required: false,
        default: false,
      },
      ssn: {
        type: String,
        default: '',
      },
      applicationId: {
        type: String,
        default: '',
      },

      /** -----------------
       *  eidsNoApplication
       *  ----------------- */

      eidsNoApplicationTitle: {
        type: String,
        default: '',
      },
      eidsNoApplicationMessage: {
        type: String,
        default: '',
      },
      eidsNoApplicationLinkTitle: {
        type: String,
        default: '',
      },
      eidsNoApplicationLinkUrl: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        agree: false,
        urlTerms: globals.urlTermsOfUse,
        prefillForm: {
          applicationGUID: "",
          ssn: "",
          showSSN: false,
          touched: false,
          error: ""
        },
        userLoggedIn: globals.userLoggedIn,
        applicationDataLoading: true,
        applicationDataResponseSuccess: false,
        // If we are using localStorage data.
        usingLocalStorage: false,
      };
    },
    mounted() {
      const queryParams = utils.generalHelpers.methods.getJSONFromURL()

      if (queryParams.application) {
        this.prefillForm.applicationGUID = queryParams.application
        this.baseLoadApplicationData();
        this.usingLocalStorage = false;

      // Old local environment hack if ?application param isn't working correctly.
      } else if (queryParams.applicationlocal) {
        this.prefillForm.applicationGUID = queryParams.applicationlocal

        // We are setting these to simulate LoadApplicationData()
        this.usingLocalStorage = true;
      }
      else {
        this.usingLocalStorage = true;
      }

      // When the page is restored from bfcache (e.g. after Signicat redirect),
      // re-run load logic so applicationDataResponseSuccess and view stay in sync with localStorage.
      globalThis.addEventListener('pageshow', this.onPageshow);
    },
    beforeUnmount() {
      globalThis.removeEventListener('pageshow', this.onPageshow);
    },
    computed: {
      labelAgree() {
        const base = this.translate('Olen tarkistanut tietojen oikeellisuuden ja %s.');
        const parts = base.split('%s');
        return {
          insertLink: parts.length > 1,
          start: parts.shift(),
          end: parts.join(''),
        };
      },
      textFixedControls() {
        if (this.applicationType == 'owner-occupancy') {
          return this.isExistingApplication
          ? this.translate('Omistusasuntohakemus: Kelluva muistutus, varauksen päivitys')
          : this.translate('Omistusasuntohakemus: Kelluva muistutus, varauksen lähetys');
        } else {
          return this.isExistingApplication
          ? this.translate('Asuntohakemus: Kelluva muistutus, hakemuksen päivitys')
          : this.translate('Asuntohakemus: Kelluva muistutus, hakemuksen lähetys');
        }
      },
      textReset() {
        if(this.applicationType == 'owner-occupancy') {
          return this.isExistingApplication
            ? this.translate('Omistusasuntovaraus: Kirjaudu ulos')
            : this.translate('Omistusasuntovaraus: Tyhjennä varaus');
      } else {
          return this.isExistingApplication
            ? this.translate('Asuntohakemus: Kirjaudu ulos')
            : this.translate('Asuntohakemus: Tyhjennä hakemus');
          }
      },
      textResetConfirm() {
        if (this.applicationType == 'owner-occupancy') {
          return this.isExistingApplication
            ? this.translate('Omistusasuntovaraus: Kirjaudu ulos, vahvistus')
            : this.translate('Omistusasuntovaraus: Tyhjennä varaus, vahvistus');
        } else {
          return this.isExistingApplication
            ? this.translate('Asuntohakemus: Kirjaudu ulos, vahvistus')
            : this.translate('Asuntohakemus: Tyhjennä hakemus, vahvistus');
        }
      },
      textSubmit() {
        if (this.applicationType == 'owner-occupancy') {
          return this.translate(this.isExistingApplication ? 'Päivitä varaus' : 'Jätä varaus');
        } else {
          return this.translate(this.isExistingApplication ? 'Päivitä hakemus' : 'Jätä hakemus');
        }
      },
      textDeactivate() {
        return this.translate('Hakemukseni ei ole enää ajankohtainen');
      },
      textDeactivateConfirmTitle() {
        return this.translate('Haluatko varmasti poistaa hakemuksesi?');
      },
      textDeactivateConfirmText() {
        return this.translate('Hakemuksesi poistetaan etkä enää saa asuntotarjouksia.');
      },
      textDeactivateButton() {
        return this.translate('Poista hakemus');
      },
      /** Debug: logs the same inputs as the “Täytä puuttuvat kentät.” banner v-if used. */
      showSubmitValidationBanner() {
        const v = this.validations;
        const invalid = !!(v && v.$invalid);
        const error = !!(v && v.$error);
        const visible = (this.formSubmitAttempted && invalid) || error;
        console.log('[ApplicationBase] submit validation summary banner', {
          formSubmitAttempted: this.formSubmitAttempted,
          'validations.$invalid': invalid,
          'validations.$error': error,
          visible,
        });
        return visible;
      },
      submitDisabled() {
        // Keep button clickable when validation fails so user can click and see errors
        // (formSubmitAttempted + field messages + banner below).
        if(this.userLoggedIn) {
          return !this.agree || this.submitting || this.loading || !this.hasApartments;
        } else {
          return !this.agree || this.submitting || this.loading || !this.hasApartments || this.disableFormFromWordPress;
        }
      },
      /**
       * If form has errors.
       *
       * @return bool true has errors, false no errors.
       */
      prefillFormHasErrors() {

        if ( this.isValidSSN ) {
          return false;
        }

        return true;
      },
      formDisabledContent() {
        return globals.formDisabledFromWordPressReason;
      },
      isValidSSN() {
        return FinnishSSN.validate( this.ssn.toUpperCase() )
      },
    },
    methods: {
      onPageshow(event) {
        if (event.persisted) {
          const queryParams = utils.generalHelpers.methods.getJSONFromURL();
          if (queryParams.application) {
            this.prefillForm.applicationGUID = queryParams.application;
            this.usingLocalStorage = false;
            this.baseLoadApplicationData();
          }
        }
      },
      validateSSN: FinnishSSN.validate,
      validatePrefillFormSSN() {
        if (this.prefillForm.touched && !FinnishSSN.validate(this.prefillForm.ssn.toUpperCase())) {
          this.prefillForm.error = this.translate(`${this.applicationType}: Tarkista henkilötunnus`)
        }
      },
      move(to) {
        if (to === 'submit') {
          const errors = this.getValidationErrors(this.validations);
        }
        this.$emit('move', to)
      },
      getValidationErrors(v, path = '') {
        const errors = [];
        if (!v) return errors;

        for (const key in v) {
          if (key.startsWith('$')) continue;

          const field = v[key];
          const fieldPath = path ? `${path}.${key}` : key;

          if (field && typeof field === 'object') {
            // Tarkista onko tämä kenttä jolla on $invalid
            if (typeof field.$invalid !== 'undefined') {
              if (field.$invalid) {
                const failedRules = [];
                for (const rule in field) {
                  if (!rule.startsWith('$') && typeof field[rule] === 'boolean' && field[rule] === false) {
                    failedRules.push(rule);
                  }
                }
                errors.push({
                  kenttä: fieldPath,
                  virheellinenSääntö: failedRules.join(', ') || 'tuntematon',
                  $invalid: field.$invalid,
                  $dirty: field.$dirty,
                  $error: field.$error
                });
              }
            }
            // Käy läpi sisäkkäiset kentät
            const nestedErrors = this.getValidationErrors(field, fieldPath);
            errors.push(...nestedErrors);
          }
        }
        return errors;
      },
      print() {
        window.print();
      },
      getLocalStorageApplicationId( type ) {
        const key = `application[${type}]`;
        const value = localStorage.getItem(key);

        try {
          return JSON.parse(value).form.Id; // Try parsing JSON
        } catch {
          return value; // Return raw string if not JSON
        }
      },
      // ApplicationBase's application data fetching method.
      baseLoadApplicationData() {

        // If localstorage has FormId we don't need to fetch data from Laravel.
        const localStorageFormId = this.getLocalStorageApplicationId( this.applicationTypeOriginal );

        const queryParams             = utils.generalHelpers.methods.getJSONFromURL()
        const queryParamApplicationId = queryParams?.application ?? null;

        // If application id was found.
        if ( localStorageFormId ) {
          this.applicationDataResponseSuccess = true;
          this.applicationDataLoading = false;

          if ( queryParamApplicationId && queryParamApplicationId !== localStorageFormId ) {

            this.updateRefererCookie( 'no-match-found', localStorageFormId );
            this.logoutUser();
          }

          return;
        }

        if ( !this.ssn && !this.applicationId && !this.applicationType ) {
          return;
        }

        // Do the query.
        const loadingPromise = this.loadApplicationDataFromAPI(
          this.applicationType
        );

        // Ensure the component handles the loading state even if loadApplicationDataFromAPI
        // is not provided or not asynchronous.
        if (loadingPromise && typeof loadingPromise.then === 'function') {
          loadingPromise
            .then(response => {

              if (!response) {
                console.error("API call resolved successfully, but returned no data/response object.");
                // Treat this as a failure to load data
                this.applicationDataResponseSuccess = false;
                this.updateRefererCookie( 'no-match-found', queryParamApplicationId );
                this.logoutUser();

                return; // Exit the .then() block
              }

              // If request success.
              if (response && response.success === true) {

                const responseApplicationDataId = response?.applicationData?.Id ?? null;

                // Fail and logout if queryParamApplicationId doesn't match.
                if (
                  ( responseApplicationDataId && queryParamApplicationId ) &&
                  responseApplicationDataId !== queryParamApplicationId
                ) {
                  this.applicationDataResponseSuccess = false;
                  this.updateRefererCookie( 'no-match-found', responseApplicationDataId );
                  this.logoutUser();
                }

                this.applicationDataResponseSuccess = true;
                return;

              }
              else {
                this.applicationDataResponseSuccess = false;

                this.updateRefererCookie( 'no-match-found', queryParamApplicationId );

                this.logoutUser();
              }
            })
            .finally(() => {
              this.applicationDataLoading = false;
            });
        } else {
          // Fallback for synchronous/non-promise load functions
          this.applicationDataLoading = false;
        }
      },
      updateRefererCookie( state, applicationId ) {

        /**
         * If user has navigated to different view from the application view
         * the ?application param will be lost.
         * Here we add application param if needed.
         */
        const applicationUrlWithApplicationParam = maybeAddQueryParam(
          window.location.href,
          'application',
          applicationId
        );

        const refererUrlUpdated = createURLWithParams(
          applicationUrlWithApplicationParam,
          {
            'state': state
          }
        );
        updateCookieWithString('referer_cookie', refererUrlUpdated,null, globals.refererCookieSettings );
      },
      getQueryParam(paramName) {
        // 1. Get the full query string (everything after '?') from the current URL
        const queryString = window.location.search;

        // 2. Create a URLSearchParams object to easily work with parameters
        const urlParams = new URLSearchParams(queryString);

        return urlParams.get(paramName) ?? '';
      },
    },// Methods ends.
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .application-base {
    margin-top: $theme-spacing * 2;
    margin-bottom: r(128);
    &--success {
      display: none;
    }
    @media print {
      margin-bottom: 0;
      &--success {
        display: block;
      }
    }

    h1 {
      margin-top: r(40);
      margin-bottom: r(40);

      @include media-breakpoint-up(lg) {
        margin-top: r(80);
        margin-bottom: r(80);
      }
    }

    .form-check-label {
      margin-left: $theme-spacing * 0.25;
    }
  }

  .application-base__top {
    margin-bottom: r(32);
  }

  .application-base__top-slot {
    margin-top: r(64);

    .application-base--preview & {
      margin-top: 0;
    }
  }

  .application-base__instructions {
    @include font-responsive-body-large;
  }

  .application-base__apartments {
    margin-bottom: r(32);
    margin-top: r(16);
  }

  .application-base__text-after {
    text-align: center;
    margin: r(50) 0;
    flex-direction: column;
  }

  .application-base__center-button .btn{
    padding-left: 0;
  }

  .application-base__error {
    color: $color-red;
  }

  .application-base__btn-wide {
    width: r(300);
    max-width: 100%;
  }

  .application-base__print-icon {
    margin: r(-14) 0;

    svg {
      @include square(r(28));
    }
  }

  .application-base__bottom-grid {

    display: flex;
    flex-flow: column;

    @include media-breakpoint-up(md) {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-flow: row;
    }
  }

  .application-base__bottom-grid-item {
    &--left {
      order: 2;
      margin-top: r(24);

      @include media-breakpoint-up(md) {
        margin: 0;
        order: 1;
      }
    }

    &--right {
      order: 1;

      @include media-breakpoint-up(md) {
        align-items: flex-end;
        margin-left: r(24);
        order: 2;
      }
    }
  }

  .application-base__bottom-grid-column {
    display: flex;
    flex-direction: column;

    @include media-breakpoint-up(md) {
      align-items: flex-start;
    }
  }

  .application-base__bottom-label, .application-base__center-button {
    margin-bottom: r(12);

    @include media-breakpoint-up(md) {
      margin-bottom: r(24);
    }
  }

  .application-base__terms-link {
    text-decoration: underline;
    color: $color-green-2025;
    margin-left: $theme-spacing * 0.5;
  }

  .application-base__controls-fixed {
    @include card;
    position: fixed;
    z-index: 10;
    left: 0;
    right: 0;
    bottom: 0;
    padding: r(8);
    border-radius: 0;
    background-color: $color-white;

    @include media-breakpoint-up(sm) {
      border-top-left-radius: r(4);
      left: auto;
    }
  }

  .application-base__controls-fixed-text {
    @include font-body-10;
    width: 100%;
    margin-bottom: r(8);
    text-align: center;

    @include media-breakpoint-up(md) {
      @include font-body-12;
    }
  }

  .application-base__controls-fixed-buttons {
    display: flex;
    justify-content: space-between;
  }

  .application-base__controls-fixed-submit {
    margin-left: r(24);
  }

  .avain_application_errorLabel {
    background: transparent;
    color: #ff1515;
    font-size: 14px;
    line-height: 15.5px;
    margin-bottom: 8px;
    margin-top: -12px;
  }
</style>
